import React from 'react';
import { accountHook } from '../lib/domHooks';

/** Durum rozeti (Beklemede / Onaylandı / Reddedildi …).
 *
 * Rengin kendisi duruma göre değişir ve bir süre üç özellik birden satır içi
 * stille yazılıyordu (`background`, `color`, `border`) — panelden yazılan CSS
 * onları ancak `!important` ile ezebiliyordu. Artık yalnızca renk bir CSS
 * değişkeniyle taşınır (`--bhs-status`), çizimi sınıf yapar (App.css
 * `.account-status-badge`). Rozet `[data-bhs-account="badge"]` ile seçilir;
 * hangi durumda olduğu `data-bhs-status` niteliğindedir.
 */
const StatusBadge = ({
  color, status, className = '', children,
}) => (
  <span
    className={`account-status-badge ${className}`.trim()}
    style={color ? { '--bhs-status': color } : undefined}
    data-bhs-status={status || undefined}
    {...accountHook('badge')}
  >
    {children}
  </span>
);

export default StatusBadge;
